import { z } from 'zod';
import { OfferSchema } from '~entities/offer/model/offer.contracts';
import { OccupancySchema } from '~processes/booking/model/booking.contracts';

export const CalendarDaySchema = z
  .object({
    arrivalDay: z.string(),
    arrivalRestricted: z.boolean(),
    dayRestricted: z.boolean(),
    departureRestricted: z.boolean(),
    minimumStayDuration: z.number(),
    offers: z.array(OfferSchema),
  })
  .transform(day => ({
    ...day,
    offers: day.offers.sort((a, b) => a.nights - b.nights),
  }));

export const CalendarMonthQuerySchema = z.object({
  occupancy: OccupancySchema,
  month: z.string().optional(),
  packageGroupId: z.number().optional(),
});

export const CalendarMonthQueryDtoSchema = z.object({
  adults: z.number().min(1),
  arrivalMonth: z.string().optional(),
  children: z.array(z.number()),
  oneIdentifier: z.string(),
  packageGroupId: z.number().optional(),
});

export const CalendarDayQuerySchema = z.object({
  occupancy: OccupancySchema,
  day: z.string(),
  packageGroupId: z.number().optional(),
});

export const CalendarDayQueryDtoSchema = z.object({
  adults: z.number().min(1),
  arrivalDay: z.string(),
  children: z.array(z.number()),
  oneIdentifier: z.string(),
  packageGroupId: z.number().optional(),
});

export const CalendarMonthSchema = z.object({
  arrivalMonth: z.string(),
  days: z.array(
    z.object({
      date: z.string(),
      minimumDayPrice: z
        .object({
          amount: z.number(),
          currency: z.string(),
          symbol: z.string(),
        })
        .optional(),
      arrivalRestricted: z.boolean(),
      departureRestricted: z.boolean(),
      dayRestricted: z.boolean(),
      minimumStayDuration: z.number(),
    }),
  ),
});
